import { QuinnPromptOption } from "../../types";

type QuinnPromptChipsProps = {
    options: QuinnPromptOption[];
    selected: string[];
    disabled: boolean;
    onToggle: (value: string) => void;
};

export function QuinnPromptChips({ options, selected, disabled, onToggle }: QuinnPromptChipsProps) {
    return (
        <div className="mt-2.5 flex flex-wrap gap-1.5">
            {options.map((option) => {
                const isSelected = selected.includes(option.value);
                return (
                    <button
                        key={option.value}
                        type="button"
                        disabled={disabled}
                        onClick={() => onToggle(option.value)}
                        className={`group inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-colors disabled:opacity-50 ${
                            isSelected
                                ? "border-primary bg-primary text-white"
                                : "border-gray-200 bg-white text-gray-700 hover:border-primary/40 hover:bg-primary/5"
                        }`}
                    >
                        {option.label}
                        {option.hint && (
                            <span className={isSelected ? "text-white/70" : "text-gray-400"}>{option.hint}</span>
                        )}
                    </button>
                );
            })}
        </div>
    );
}
